export default __webpack_public_path__ + "static/media/029-champagne.e6cf910e.svg";